module.exports = __webpack_public_path__ + "static/media/background-placement-2x-01.6ba71a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/background-placement-2x-01.png
// module id = 1804
// module chunks = 0